// Shared Recharts style constants. Imported by Dashboard, Ladder, Dividends.
// Extracting these out of JSX prevents fresh object identity on every render,
// which made Recharts re-mount tooltip/axis components unnecessarily.
//
// Brand palette tokens (mirror tailwind config in /app/frontend/src/index.css):
//   champagne #f2f2f2 · stone #dbd6d2 · paars #d7b5c9 · paars-dark #9e8193
//   groen #88a17e · burgundy #a86464 · gold #c9b896 · graphite #1e1e1c

export const AXIS_STROKE = "#9e8193";
export const AXIS_LINE = { stroke: "#27272A" };
export const GRID_STROKE = "#dbd6d2";

export const TOOLTIP_CONTENT_STYLE = {
  background: "#ffffff",
  border: "1px solid #dbd6d2",
  borderRadius: 0,
  fontSize: 12,
  fontFamily: "JetBrains Mono",
};

export const TOOLTIP_ITEM_STYLE = { color: "#9e8193" };
export const TOOLTIP_LABEL_STYLE = { color: "#1e1e1c" };
export const TOOLTIP_CURSOR_PAARS = { fill: "rgba(215, 181, 201, 0.18)" };

export const LEGEND_WRAPPER_STYLE = {
  fontSize: 11,
  fontFamily: "JetBrains Mono",
  color: "#1e1e1c",
  paddingTop: 12,
};

// $ formatters
export const dollarTick = (v) => `$${v}`;
export const dollarTooltip = (v) => `$${v.toFixed(2)}`;
